import styled, { css } from 'styled-components';

export const StyledDataCell = styled.td`
  ${props => props.alignRight && 'text-align: right'};
  padding-top: ${props => (props.editMode ? '3px' : '12px')};
  padding-bottom: ${props => (props.editMode ? '3px' : '12px')};
  ${({ editMode, dense }) => {
    if (editMode || dense) {
      return css`
        padding-top: 3px;
        padding-bottom: 3px;
      `;
    }

    return css`
      padding-top: 12px;
      padding-bottom: 12px;
    `;
  }}
  padding-left: ${({ alignRight }) => alignRight && '12px'};
  &:first-child {
    padding-left: 10px;
  }
  border-top: ${({ footer, theme }) => footer && `thin solid ${theme.borderColor}`};
  background-color: ${({ overwriteGlobalCSS }) => (overwriteGlobalCSS ? 'inherit !important' : '')};
  padding-right: ${props => props.last && '10px'};

  ${(props) => {
    if (props.privateMode) {
      return css`
        color: transparent;
        text-shadow: 0 0 25px rgba(0, 0, 0, 0.25);
        :hover {
          color: #000;
          text-shadow: none;
        }
      `;
    }
    return '';
  }};

  white-space: ${props => (props.whiteSpace ? props.whiteSpace : 'pre-line')};
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 1px;

  @media print {
    padding: 8px 0;
  }

  @media only screen and (max-width: ${props =>
    (props.mobileSize ? `${props.mobileSize}px` : '580px')}) {
    ${props => (props.mobile ? 'display: table-cell' : 'display: none')};
    max-width: auto;

    text-overflow: normal;
    white-space: normal;
  }
`;
